export var t = function (key, translations, forceLocale) {
    var locale = forceLocale !== null && forceLocale !== void 0 ? forceLocale : global.App.locale.locale;
    var translation = translations.find(function (t) { return t.locale === locale && t.key === key; });
    if (!translation) {
        return null;
    }
    return translation.value;
};
